import { atom } from '@exodus/headless-ui';
import feeAmountAtom from './fee-amount.js';
import fromAssetAtom from './from-asset.js';
const feeFiatAmountAtom = atom((get, { selectors }) => {
    const fromAsset = get(fromAssetAtom);
    const fee = get(feeAmountAtom);
    const conversions = get(selectors.fiatBalances.conversions);
    return conversions[fromAsset.feeAsset.name](fee);
});
export default feeFiatAmountAtom;
